import React from 'react'

const MIN_ZOOM = 0.025
const MAX_ZOOM = 4.0

function clampZoom(value) {
  return Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, value))
}

export default function ZoomControls({ zoom, onZoom, onFit }) {
  const handleIncrease = () => onZoom(clampZoom(zoom + 0.25))
  const handleDecrease = () => onZoom(clampZoom(zoom - 0.25))
  const handleReset = () => onZoom(1.0)

  return (
    <div className="zoom-controls">
      <button className="zoom-controls__btn" onClick={onFit} title="Fit full sheet">
        Fit full sheet
      </button>
      <button className="zoom-controls__btn" onClick={handleDecrease} title="Zoom out 25%">
        −25%
      </button>
      <span className="zoom-controls__display">
        {Math.round(zoom * 100)}%
      </span>
      <button className="zoom-controls__btn" onClick={handleIncrease} title="Zoom in 25%">
        +25%
      </button>
      <button className="zoom-controls__btn" onClick={handleReset} title="100%">
        100%
      </button>
    </div>
  )
}
